import { ref, reactive } from '@vue/composition-api'
import { defineStore } from 'pinia'
import { appInfo } from 'wap/hybrid/device.js'

export const useAppStore = defineStore('app', () => {
  const isAppWebview = ref(appInfo.appWebview)
  const app = reactive(appInfo)

  const now = new Date().getTime()
  const isChristmasLogo = ref(now >= process.env.VUE_APP_CHRISTMAS_LOGO_START_TIME && now < process.env.VUE_APP_CHRISTMAS_LOGO_END_TIME)

  return {
    isAppWebview,
    app,
    isChristmasLogo
  }
})
